import operandType from "../../../infrastructure/constants/functions/operandType";
import assignmentHelper from "../../../infrastructure/helpers/functions/assignment/assignmentHelper";
import conditionHelper from "../../../infrastructure/helpers/functions/condition/conditionHelper";
import operandHelper from "../../../infrastructure/helpers/functions/operand/operandHelper";
import ReportCollections from "../../../infrastructure/types/Functions/ReportCollections";
import Assignment from "../../../types/functions/Assignment/Assignment";
import Condition from "../../../types/functions/Condition/Condition";
import Lookup from "../../../types/functions/Lookup";
import Operand from "../../../types/functions/Operand/Operand";
import ComponentType from "../../../types/report/ComponentType";
import GlobalModuleConfig from "../../../types/report/GlobalModuleConfig";
import IdNameAndNumber from "../../../types/report/IdNameAndNumber";
import Mode from "../../../types/report/Mode";
import RefDataSource from "../../../types/report/RefDataSource";
import ReportConfig from "../../../types/report/ReportConfig";
import ReportVariable from "../../../types/report/ReportVariable";
import UserDefinedFunction from "../../../types/report/UserDefinedFunction";

const getByConditionReferencesInGlobalConfig = (globalConfig: GlobalModuleConfig,
    condition: Condition,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existinDatasourcesIds: Set<number>,
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
    existingInReportConfigVariablesIds?: Set<number>,
    resultVariables?: ReportVariable[],
) => {

    operandHelper.proceedWhitCondition(condition, ((operand: Operand) => {

        proceed(operand,
            globalConfig,
            resultLookups,
            resulFunctions,
            existinDatasourcesIds,
            existingInReportConfigLookupsIds,
            existingInReportConfigUdfsIds,
            existingInReportConfigVariablesIds,
            resultVariables
        );
    }));
}
const getByAssignmentReferencesInGlobalConfig = (globalConfig: GlobalModuleConfig,
    assignment: Assignment,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existinDatasourcesIds: Set<number>,
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
    existingInReportConfigVariablesIds?: Set<number>,
    resultVariables?: ReportVariable[],
) => {

    operandHelper.proceedWhitAssignment(assignment, ((operand: Operand) => {

        proceed(operand,
            globalConfig,
            resultLookups,
            resulFunctions,
            existinDatasourcesIds,
            existingInReportConfigLookupsIds,
            existingInReportConfigUdfsIds,
            existingInReportConfigVariablesIds,
            resultVariables
        );
    }));
}

const proceed = (operand: Operand,
    globalConfig: GlobalModuleConfig,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existinDatasourcesIds: Set<number>,
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
    existingInReportConfigVariablesIds?: Set<number>,
    resultVariables?: ReportVariable[],
) => {

    if (operand.lookupNumber) {

        let currentLookup = globalConfig.lookups.find(x => x.number === operand.lookupNumber) as Lookup;

        if (!existingInReportConfigLookupsIds.has(currentLookup?.id as number)) {
            resultLookups.push(currentLookup);

            existingInReportConfigLookupsIds.add(currentLookup?.id as number);

            existinDatasourcesIds.add(currentLookup.dataSource1Id as number);
            existinDatasourcesIds.add(currentLookup.dataSource2Id as number);

            getByConditionReferencesInGlobalConfig(globalConfig,
                currentLookup.condition,
                resultLookups,
                resulFunctions,
                existinDatasourcesIds,
                existingInReportConfigLookupsIds,
                existingInReportConfigUdfsIds,
                existingInReportConfigVariablesIds,
                resultVariables
            );
        }
    }

    if (operand.variableNumber) {

        let currentVariable = globalConfig.variables.find(x => x.number === operand.variableNumber) as ReportVariable;

        if (!existingInReportConfigVariablesIds?.has(currentVariable?.id as number)) {
            resultVariables?.push(currentVariable);

            if (currentVariable.dataSourceId && !existinDatasourcesIds.has(currentVariable.dataSourceId)) {
                existinDatasourcesIds.add(currentVariable.dataSourceId);
            }

            existingInReportConfigVariablesIds?.add(currentVariable?.id as number);

            getByAssignmentReferencesInGlobalConfig(globalConfig,
                currentVariable.assignment,
                resultLookups,
                resulFunctions,
                existinDatasourcesIds,
                existingInReportConfigLookupsIds,
                existingInReportConfigUdfsIds,
                existingInReportConfigVariablesIds,
                resultVariables
            );
        }
    }

    if (operand.functionNumber) {

        let currentFunction = globalConfig.userDefinedFunctions.find(x => x.number === operand.functionNumber) as UserDefinedFunction;

        if (!existingInReportConfigUdfsIds.has(currentFunction?.id as number)) {
            resulFunctions.push(currentFunction);

            existingInReportConfigUdfsIds.add(currentFunction?.id as number);

            getByAssignmentReferencesInGlobalConfig(globalConfig,
                currentFunction.assignment,
                resultLookups,
                resulFunctions,
                existinDatasourcesIds,
                existingInReportConfigLookupsIds,
                existingInReportConfigUdfsIds,
                existingInReportConfigVariablesIds,
                resultVariables
            );
        }

    }
}

const getGlobalModuleDetaSourceValues = (collections: ReportCollections, reportConfig: ReportConfig): string[] => {

    let globalModuleDataSourcesIds = collections?.globalModuleDataSources?.map(x => (x.id || '')?.toString()) || [];

    if (!globalModuleDataSourcesIds.length) {
        reportConfig.lookups.filter(x => x.mode === Mode.Global).forEach((lookup) => {
            globalModuleDataSourcesIds.push((lookup.dataSource1Id as number).toString());
            globalModuleDataSourcesIds.push((lookup.dataSource2Id as number).toString());
        })
    }

    return globalModuleDataSourcesIds;
}



const getAllReferencedComponents = (allOperands: Operand[], componentType: ComponentType, globalCollection: IdNameAndNumber[]): IdNameAndNumber[] => {

    let referencedComponents: IdNameAndNumber[] = [];

    allOperands.forEach(operand => {
        if (componentType === operand.operandType && operand.operandType === operandType.variable) {
            let component = globalCollection.find(x => x.number === operand.variableNumber);
            if (component) {
                referencedComponents.push(component);
            }
        }
    });

    return referencedComponents;
}

const validatePosition = (globalConfig: GlobalModuleConfig, reportConfig: ReportConfig, insertionNumber: number, globalId: number, componentType: ComponentType): string => {

    let globalCollection = [];
    let reportCollection = [];
    let allOperands = [];

    if (componentType === ComponentType.Variable) {

        globalCollection = globalConfig.variables;
        reportCollection = reportConfig.variables;

        let globalComponent = globalCollection.find(x => x.id === globalId) as ReportVariable;

        allOperands = assignmentHelper.getAllOperands(globalComponent?.assignment as Assignment);
    }
    else {
        globalCollection = globalConfig.lookups;
        reportCollection = reportConfig.lookups;

        let globalComponent = globalCollection.find(x => x.id === globalId);

        allOperands = conditionHelper.getAllOperands(globalComponent?.condition as Condition);
    }

    let referencedComponents = getAllReferencedComponents(allOperands,
        componentType,
        globalCollection as IdNameAndNumber[]);

    for (let component of referencedComponents) {

        let reportComponent = {} as IdNameAndNumber;

        if (componentType === ComponentType.Variable) {
            reportComponent = reportConfig.variables.find(x => x.globalVariableModuleId === component.id) as IdNameAndNumber;
        }
        else {
            reportComponent = reportConfig.lookups.find(x => x.globalLookupModuleId === component.id) as IdNameAndNumber;
        }

        if (reportComponent && reportComponent.number > insertionNumber) {
            return `Invalid position because ${componentType}: ${reportComponent.name}\r\n is referenced and have a number greater than insertion position.`;
        }
    };

    return '';
}

export { getAllReferencedComponents, validatePosition, getByAssignmentReferencesInGlobalConfig, getByConditionReferencesInGlobalConfig, getGlobalModuleDetaSourceValues }
